<div [ngbTooltip]="disabled ? disableTooltip : null">
  <app-new-button
    [size]="'responsive'"
    [disabled]="disabled"
    [svgIconPath]="icon"
    (click)="navigateToPlugin()"
  >
    {{ translationKey | translate }}
  </app-new-button>
</div>

